import React from 'react'
import { useTranslation } from 'react-i18next';
import ManageState from './manageState';
import TableCustom from '../../../components/table/tableCustom';
import { debouncedApiCall } from '../../../utils/app.utils';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import StateComponents from '../../../components/state-component/StateComponents';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { status_visa } from '../manage-request/enum/request-form.enum';

export default function VisaRequest() {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,

        status,
        set_status
    } = ManageState()
    const navigate = useNavigate()

    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("ส่งคำร้อง")}

                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: t("ค้นหา"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                //    {
                                //         seq: 1,
                                //         type: "SELECT",
                                //         gridProps: {
                                //             xs: 12,
                                //             md: 4
                                //         },
                                //         fieldProps: {
                                //             labelId: "ss",
                                //             heading: "",
                                //             onChange: (e) => {
                                //                 // handleChange('form_type', index, e.target.value);
                                //                 // set_id_degree(e.target.value)
                                //             },
                                //             options: [{
                                //                 label: t('LIST_APPLICANTS_ALL_LEVELS'),
                                //                 value: "ALL",
                                //             },
                                //                 // ...degree?.map((item: any) => {
                                //                 //     return {
                                //                 //         label: item?.degree_name,
                                //                 //         value: item?.id_degree,
                                //                 //     }
                                //                 // })
                                //             ],
                                //             selectId: "",
                                //             value: '',
                                //         }
                                //     },

                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("LIST_APPLICANTS_DATE_RANGE")
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            console.log(e.target.value);
                                            // handleChange('form_type', index, e.target.value);
                                            set_status(e.target.value)
                                        },
                                        options: [{
                                            label: t('สถานะทั้งหมด'),
                                            value: "ALL",
                                        },
                                        ...status_visa.map((x) => ({ ...x, label: t(x.label) }))
                                        ],
                                        selectId: "",
                                        value: status,
                                    }
                                },


                                {
                                    seq: 4,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: t("สร้างรายการส่งคำร้อง"),
                                                buttonProps: {
                                                    onClick: () => {
                                                        // setShowModal("ADD")
                                                        navigate(routeName.request_form.visa_request_create)
                                                    },
                                                },
                                                type: "ADD2"
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

        </div>
    )
}
